import { render } from "./Router1.vue?vue&type=template&id=6ea7e196&scoped=true"
import script from "./Router1.vue?vue&type=script&lang=js"
export * from "./Router1.vue?vue&type=script&lang=js"

import "./Router1.vue?vue&type=style&index=0&id=6ea7e196&lang=less&scoped=true"

import exportComponent from "D:\\zhwf\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ea7e196"]])

export default __exports__